export enum SearchErrors {
  TooLong = "TooLong",
  Unknown = "Unknown",
  Sensitive = "Sensitive",
  RateLimit = "RateLimit",
  NeedDetails = "NeedDetails",
  NoResults = "NoResults",
}
